import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "LazyTrackOrderChunks" */ './TrackOrderConnect'),
    {
        fallback: <div>Loading...</div>,
    }
);
